import IMG from "../../assets/img/Img"
import { Button } from "../tag/Button";
import { useMovePage } from "../hooks/usePageMove";
import { AuthService } from "../service/AuthService";
import { showToast } from "../utils/Toastify";
import { useGraphqlService } from "../service/GraphqlService";

export const Header = ({ setIsOpen }) => {
    const { executeMutation } = useGraphqlService();

    const { go } = useMovePage();

    const logOut = async () => {
        const DELETE_PUSH_NOTI = `
            mutation {
                deletePushNotiManage(data: {
                    COM_CD: "${AuthService.getComCd()}"
                    MEM_ID: "${AuthService.getMemId()}"
                    OLD_FCM_TOKEN: "${AuthService.getFcmToken()}"
                    NEW_FCM_TOKEN: ""
                })
            }
        `;
        try {
            await executeMutation(DELETE_PUSH_NOTI);
            AuthService.clearStorage();
            go("/auth/login");
        } catch (err) {
            console.log(err);
            showToast.error(err);
        }
    }

    return (
        <header className="flex justify-between items-center fixed top-0 left-0 w-full h-[55px] bg-[linear-gradient(145deg,#1e2a38,#0c1117)] border-b border-[#333] px-3 py-0">
            <div className="h-full flex items-center gap-3">
                <Button onClick={() => setIsOpen(prev => !prev)} style={{ backgroundImage: `url(${IMG.HAMBURGER_ICON})` }} className="flex w-[30px] h-[30px] bg-no-repeat bg-center"></Button>
                <Button onClick={() => go("/")} style={{ backgroundImage: `url(${IMG.LOGO})` }} className="flex w-[100px] h-full bg-contain bg-no-repeat bg-left bg-center"></Button>
            </div>
            <div className="h-full flex items-center">
                <Button onClick={logOut} className="w-24 h-9 flex items-center justify-center text-sm font-bold text-white bg-[#0092B8] rounded">로그아웃</Button>
            </div>
        </header>
    )
}